import countries from '../countries/countries.json'
const { uniq } = require('lodash')

// suma de ecb + FOREX eodhistoricaldata, pero posiblemente alguna más esté disponible en eodhistoricaldata
const SUPPORTED_CURRENCIES = [
  'EUR',
  'AUD',
  'BGN',
  'BRL',
  'CAD',
  'CHF',
  'CNY',
  'CZK',
  'DKK',
  'GBP',
  'HKD',
  'HRK',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'ISK',
  'JPY',
  'KRW',
  'MXN',
  'MYR',
  'NOK',
  'NZD',
  'PHP',
  'PLN',
  'RON',
  'SEK',
  'SGD',
  'THB',
  'TRY',
  'USD',
  'ZAR',
  'RUB',
  'ZAC',
  'TWD',
  'CLP',
  'MXV',
  'UYU',
  'SAR',
  'ARS',
  'COP',
  'PEN',
  'CUP',
  'PAB',
  'DOP',
]

export const supportedCurrencies = SUPPORTED_CURRENCIES
export const allCurrencies = uniq(
  countries.countries.country.map((elem) => elem.currencyCode).filter((elem) => elem !== '')
)
